import React, { useState, useEffect } from 'react';
import { Box, Button, Paper, Typography,TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import PasswordField from '../../Common/PasswordField';
import { setNewPassword, resetPassword } from '../../../actions/authentication';
import { changePasswordErrorSelector } from '../../../selectors/resetPassword';
import { setToken } from '../../../helpers/localStorageCache';

const NewPassword = ({ classes, setSignIn, token, changePassword, email }) => {
  const [password, setPassword] = useState('');
  const errorSelector = useSelector(changePasswordErrorSelector);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otp, setOTP] = useState('');
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const [region, setRegion] = useState('');
  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotPasswordError, setForgotPasswordError] = useState({});

  useEffect(
    () => {
      setError({ ...error, ...errorSelector });
    },
    [errorSelector]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorArray = {password:'',confirm_password:''}
    if(confirmPassword == ''){
      errorArray.confirm_password = 'Confirm password is required';
    }
    if(password == ''){
      errorArray.password = 'Password is required';
    }
    setError(errorArray);
    if (error?.password ==  null && error?.confirmPassword == null && errorArray.password == '' && errorArray.confirm_password == '') {
      if (changePassword) {
        return dispatch(resetPassword({ email, password, re_password: confirmPassword })).then((response) => {
          if (!response.error) {
            history.replace('/');
            return response;
          }
        });
      }
      setToken('region', region);
      dispatch(setNewPassword({ password, re_password: confirmPassword, token })).then(ack => (ack ? setSignIn(true) : null));
    }
  };
  
  return (
    <Paper className={classes.paper} elevation={0}>
      <Typography component="h1" variant="h5" className={classes.loginHeading}>
        Change Password
      </Typography>

      {error && error.message && <Typography className={classes.errorMessage}>{error.message}</Typography>}

      <form onSubmit={handleSubmit} method='post'>
        <Typography gutterBottom variant="h6" className={classes.heading}>
          New Password
        </Typography>

        <PasswordField
          name="password"
          variant="outlined"
          placeholder="********"
          errors={error}
          setErrors={setError}
          setPassword={setPassword}
          setConfirmPassword={setConfirmPassword}
          password={password}
          hintVisible={true}
        />

        <Typography gutterBottom variant="h6" className={classes.heading}>
          Confirm New Password
        </Typography>

        <PasswordField
          name="confirm_password"
          variant="outlined"
          placeholder="********"
          errors={error}
          setErrors={setError}
          setPassword={setPassword}
          setConfirmPassword={setConfirmPassword}
          password={confirmPassword}
          comaparePassword={password}
          hintVisible={true}
        />
        {/* <Typography gutterBottom variant="h6" className={classes.heading}>
          Enter OTP
        </Typography> */}
        {/* <TextField
          name="otp"
          variant="outlined" 
          placeholder="********"
          errors={error}
          setErrors={setError}
          setPassword={setOTP}
          otp={otp}
        /> */}

        <Button fullWidth className={classes.submitButton} type="submit">
          Change Password
        </Button>
      </form>
      <Box style={{ cursor: 'pointer' }} textAlign="center" fontSize={15} m={2} onClick={() => setSignIn(true)}>
        <Typography>Sign In</Typography>
      </Box>
    </Paper>
  );
};

export default NewPassword;
